export const APP_URL = 'https://app.uplivion.life';

// Feature flags
export const FEATURE_CHALLENGES = false;
